import { Fragment, useContext } from "react";
// import { Outlet } from "react-router-dom";

import CartIcon from "../../components/cart-icon/cart-icon.component";
import CartDropdown from "../../components/cart-dropdown/cart-dropdown.component";

import { ReactComponent as CrownLogo } from "../../assets/crown.svg";
import { UserContext } from "../../contexts/user.context";
import { CartContext } from "../../contexts/cart.context";
import { SignOutUser } from "../../utils/firebase/firebase.utils";

import {
  NavigationContainer,
  LogoContainer,
  LogoImage,
  Brand,
  NavLinksWrapper,
  NavInner,
  NavLink,
} from "./navigation.styles";

const Navigation = () => {
  const { currentUser } = useContext(UserContext);
  const { isCartOpen } = useContext(CartContext);

  return (
    <Fragment>
      <NavigationContainer>
        <NavInner>
          <LogoContainer to="/" aria-label="Go to Team Bakery home page">
            <LogoImage>
              <CrownLogo />
            </LogoImage>
            <Brand>TEAM Bakery</Brand>
          </LogoContainer>

          <NavLinksWrapper aria-label="Main navigation">
            <NavLink to="/home">Home</NavLink>
            <NavLink to="/home/shop">Shop</NavLink>
            <NavLink to="/auth">Sign In</NavLink>
          </NavLinksWrapper>
        </NavInner>
      </NavigationContainer>

    </Fragment>
  );
};

export default Navigation;
